export enum SubsidiaryIds {
  USA = "ILOQ_USA_INC",
  FINLAND = "ILOQ_OY",
}
